<template>
	<div v-loading="loading">
		<div style="overflow-y: auto; height: 600px">
			<div class="basicInfo" v-if="type === 0">
				<el-form :model="dataObj" label-width="80px" class="client-form compact-form" label-position="top" size="mini">
					<el-row :gutter="20">
						<el-col :span="12">
							<el-form-item label="客户姓名">
								<el-input v-model="dataObj.customerName" disabled></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="联系方式">
								<el-input v-model="dataObj.contactInfo" disabled></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="12">
							<el-form-item label="需求类型">
								<el-input v-model="dataObj.demandTypeDesc" disabled></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="跟进记录">
								<el-input v-model="dataObj.consumptionWillingnessDesc" disabled></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="12">
							<el-form-item label="线索类型">
								<el-input v-model="dataObj.leadTypeDesc" disabled></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="线索来源">
								<el-input v-model="dataObj.leadSourceDesc" disabled></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="12">
							<el-form-item label="跟进人">
								<el-input v-model="dataObj.followUpPersonName" disabled></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="下次跟进时间">
								<el-input v-model="dataObj.nextFollowUpTime" disabled></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="12">
							<el-form-item label="行政区划">
								<region-cascader :disabled="true" v-model="dataObj.administrativeDivision" :options="cityList" />
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="详细地址">
								<el-input v-model="dataObj.detailedAddress" disabled></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="12">
							<el-form-item label="创建人">
								<el-input v-model="dataObj.createPersonName" disabled></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="线索创建日期">
								<el-input v-model="dataObj.createTime" disabled></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="12">
							<el-form-item label="线索状态">
								<el-input v-model="dataObj.clueStatusDesc" disabled></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="备注">
								<el-input type="textarea" v-model="dataObj.remarks" disabled></el-input>
							</el-form-item>
						</el-col>
					</el-row>
				</el-form>
			</div>
			<div class="basicInfo" v-if="type === 1">
				<el-form :model="dataObj" label-width="80px" class="client-form compact-form" label-position="top" size="mini">
					<el-row :gutter="20">
						<el-col :span="12">
							<el-form-item label="客户姓名">
								<el-input v-model="dataObj.customerName" disabled></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="联系方式">
								<el-input v-model="dataObj.contactInfo" disabled></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="12">
							<el-form-item label="需求类型">
								<el-input v-model="dataObj.demandTypeDesc" disabled></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="跟进记录">
								<el-select
									v-model="dataObj.consumptionWillingness"
									placeholder="请选择跟进记录"
									@change="changePurpose">
									<el-option
										v-for="(item, index) in consumptionWillingnessDict"
										:key="index"
										:label="item.name"
										:value="item.itemCode"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="12">
							<el-form-item label="下次跟进时间">
								<el-date-picker
									v-model="dataObj.nextFollowUpTime"
									type="datetime"
									value-format="yyyy-MM-dd HH:mm:ss"
									placeholder="请选择下次跟进时间"
									@change="changeNextFollowTime" />
							</el-form-item>
						</el-col>
					</el-row>
				</el-form>

				<div class="follow-record-container">
					<el-button
						type="primary"
						class="add-record-btn"
						icon="el-icon-plus"
						size="mini"
						@click="showFollowRecordForm = !showFollowRecordForm">
						{{ showFollowRecordForm ? '取消添加' : '添加跟进记录' }}
					</el-button>

					<div v-if="showFollowRecordForm" class="follow-record-form">
						<el-form :model="form" label-width="120px" :rules="rules" ref="form" label-position="top" size="mini">
							<el-row :gutter="20">
								<el-col :span="12">
									<el-form-item label="本次跟进目的" prop="direction">
										<el-input v-model="form.direction" placeholder="请输入本次跟进目的"></el-input>
									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item label="跟进人" prop="followUpPerson">
										<el-input v-model="followUpPerson" disabled></el-input>
									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item label="本次跟进结果" prop="result">
										<el-input v-model="form.result" type="textarea" placeholder="请输入本次跟进结果"></el-input>
									</el-form-item>
								</el-col>
							</el-row>
						</el-form>
						<div style="text-align: right">
							<el-button type="primary" @click="submitFollowRecord('form')">确认</el-button>
						</div>
					</div>
				</div>
			</div>
			<el-divider></el-divider>
			<div>
				<div class="history-title">历史跟进记录</div>

				<div class="history-record">
					<div class="record-item" v-for="(item, index) in followRecordObj.followList" :key="index">
						<div class="record-header">
							<div class="record-datetime">{{ item.createTime }}</div>
							<div class="record-entry-type">{{ item.source == 1 ? '手动录入' : '系统导入' }}</div>
							<div class="record-operator">跟进人： {{ item.operatorName }}</div>
						</div>

						<div class="record-content" v-if="item.record">
							<div class="record-tag system-record">系统记录</div>
							<div class="record-text-container">{{ item.record }}</div>
						</div>

						<div class="record-content" v-if="item.direction">
							<div class="record-tag follow-purpose">本次跟进目的</div>
							<div class="record-text-container">{{ item.direction }}</div>
						</div>

						<div class="record-content" v-if="item.result">
							<div class="record-tag follow-purpose">本次跟进结果</div>
							<div class="record-text-container">{{ item.result }}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="action-buttons">
			<el-button @click="goBack">取消</el-button>
		</div>
	</div>
</template>

<script>
	// import * as clueApi from '@/api/clueNew'
	import RegionCascader from '@/components/RegionCascader/index.vue';
	import citys from '@/utils/city';
	export default {
		components: { RegionCascader },
		props: {
			type: {
				type: Number,
				default: 0,
			},
			editData: {
				type: Object,
				default: () => {
					return {};
				},
			},
			consumptionWillingnessDict: {
				type: Array,
				default: () => {
					return [];
				},
			},
		},
		data() {
			return {
				// 跟进人-该用户
				followUpPerson: this.editData.followUpPersonName,
				// 表单数据
				form: {
					direction: '',
					result: '',
				},
				// 表单验证规则
				rules: {
					direction: [{ required: true, message: '请输入本次跟进目的', trigger: 'blur' }],
					result: [{ required: true, message: '请输入本次跟进结果', trigger: 'blur' }],
				},
				// 添加跟进记录弹窗
				innerVisible: false,
				// 显示跟进记录表单
				showFollowRecordForm: false,
				// 线索详情
				dataObj: {},
				// 加载状态
				loading: false,
				// 跟进历史详情数据
				followRecordObj: {},
				cityList: citys,
			};
		},
		mounted() {
			this.getClueDetail(); // 获取线索详情
			this.getFollowHistory(); // 获取跟进历史
		},
		methods: {
			// 获取线索详情
			getClueDetail() {
				// clueApi.getClueById({ clueId: this.editData.id }).then(res => {
				//   this.dataObj = res
				// })
			},
			// 获取跟进历史
			getFollowHistory() {
				this.loading = true;
				// clueApi.getFollowHistory({ clueId: this.editData.id }).then(res => {
				//   this.followRecordObj = res
				//   this.loading = false
				// }).catch(() => {
				//   this.loading = false
				// })
			},
			// 获取跟进标签字典
			// 返回
			goBack() {
				this.$emit('hideDialog');
			},
			// 添加跟进记录
			addFollowRecord() {
				this.showFollowRecordForm = true;
			},
			// 跟进记录选择
			changePurpose(value) {
				this.loading = true;
				// clueApi.updateClue(this.dataObj).then(res => {
				//   this.loading = false
				//   this.$message.success('修改成功')
				//   this.getClueDetail()
				// }).catch(() => {
				//   this.loading = false
				// })
			},
			// 下次跟进时间选择
			changeNextFollowTime(value) {
				this.loading = true;
				// clueApi.updateClue(this.dataObj).then(res => {
				//   this.loading = false
				//   this.$message.success('修改成功')
				//   this.getClueDetail()
				// }).catch(() => {
				//   this.loading = false
				// })
			},
			// 提交跟进记录
			submitFollowRecord(form) {
				this.$refs[form].validate(valid => {
					if (valid) {
						this.loading = true;
						// clueApi.addFollowRecord({
						//   id: this.editData.id,
						//   ...this.form
						// }).then(res => {
						//   this.showFollowRecordForm = false
						//   this.$message.success('添加跟进记录成功')
						//   this.form = {
						//     direction: '',
						//     result: ''
						//   }
						//   this.getFollowHistory()
						// }).catch(() => {
						//   this.loading = false
						//   this.$message.error('添加跟进记录失败')
						// })
					}
				});
			},
		},
	};
</script>

<style lang="scss" scoped>
	.basicInfo {
		padding: 0 15px;
	}

	:deep(.el-form-item--mini.el-form-item) {
		margin-bottom: 10px !important;
	}

	.dialog-title {
		font-size: 18px;
		font-weight: bold;
		margin-bottom: 20px;
		text-align: center;
	}

	.client-form {
		margin-bottom: 20px;

		// Reduce vertical spacing
		:deep(.el-form-item) {
			margin-bottom: 10px;
		}

		:deep(.el-form-item__label) {
			padding-bottom: 4px;
		}

		// Adjust row spacing
		.el-row {
			margin-bottom: 0;
		}
	}

	.compact-form {
		:deep(.el-input__inner) {
			height: 28px;
			line-height: 28px;
		}

		.el-row + .el-row {
			margin-top: 5px;
		}

		:deep(.el-textarea__inner) {
			min-height: 28px !important;
		}
	}

	.follow-record-container {
		margin-top: 20px;
	}

	.add-record-btn {
		margin-bottom: 15px;
	}

	.follow-record-form {
		// background-color: #f8f8f8;
		padding: 20px;
		border-radius: 4px;
		margin-bottom: l5px;
	}

	.history-title {
		font-size: 16px;
		font-weight: 600;
		margin-bottom: 15px;
	}

	.history-record {
		width: 100%;
		// max-height: 400px;
		background-color: #f5f5f5;
		padding: 10px;
		border-radius: 4px;

		.record-item {
			margin-bottom: 20px;
			padding-bottom: 15px;
			border-bottom: 1px dashed #ddd;

			&:last-child {
				border-bottom: none;
			}

			.record-header {
				display: flex;
				align-items: center;
				margin-bottom: 10px;

				.record-datetime {
					background-color: #fff;
					border: 1px solid #ddd;
					border-radius: 4px;
					padding: 4px 8px;
					font-size: 13px;
					margin-right: 10px;
				}

				.record-entry-type {
					background-color: #fff;
					border: 1px solid #ddd;
					border-radius: 4px;
					padding: 4px 8px;
					font-size: 13px;
					margin-right: 10px;
				}

				.record-operator {
					background-color: #fff;
					border: 1px solid #ddd;
					border-radius: 4px;
					padding: 4px 8px;
					font-size: 13px;
				}
			}

			.record-content {
				margin-left: 30px;
				display: flex;
				margin-bottom: 8px;

				.record-tag {
					min-width: 90px;
					padding: 4px 8px;
					text-align: center;
					color: #3d3d3d;
					border-radius: 4px;
					font-size: 13px;

					&.system-record {
						z-index: 999;
						width: 100px;
						height: 25px;
						background: url('./img/bg1.png') no-repeat;
						background-size: 100% 100%;
					}

					&.follow-purpose {
						z-index: 999;
						width: 100px;
						height: 25px;
						background: url('./img/bg2.png') no-repeat;
						background-size: 100% 100%;
						color: #fff;
					}
				}

				.record-text-container {
					flex: 1;
					background-color: #fff;
					border: 1px solid #ddd;
					border-radius: 4px;
					padding: 0 15px;
					min-height: 24px;
					line-height: 24px;
					transform: translateX(-10px);
				}
			}
		}
	}

	.follow-status-section {
		padding: 0 15px 15px 15px;
	}

	.follow-status-header {
		font-weight: 600;
		margin-bottom: 6px;
	}

	.action-buttons {
		text-align: right;
		margin-top: 20px;
	}
</style>
